import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberOrString'
})
export class NumberOrString implements PipeTransform {
  transform(value: unknown): 'number' | 'string' {
    // 1. Handle empty states immediately
    if (['', undefined, null].some(v => v === value)) {
      return 'string';
    }
    // 2. Handle proper numbers
    if (typeof value === 'number') {
      return 'number';
    }
    // 3. Cast to a string and trim whitespace for safe manipulation
    let sanitizedValue = String(value).trim();
    // 4. Handle negative currencies ID'd by parentheses
    if (sanitizedValue.startsWith('(') && sanitizedValue.endsWith(')')) {
      sanitizedValue = sanitizedValue.slice(1, -1);
    }
    const cleanedValue = sanitizedValue.replace(/[,$\xA3\u20AC%]/g, '');
    if (cleanedValue.startsWith('(') && cleanedValue.endsWith(')')) {
      sanitizedValue = cleanedValue.slice(1, -1);
    } else {
      sanitizedValue = cleanedValue;
    }
    const numericValue = Number(sanitizedValue);
    return !isNaN(numericValue) && sanitizedValue !== '' ? 'number' : 'string';
  }
}
